const jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

class LimitedList {

  constructor(lists) {
    this._lists = lists;

    this._lists.each((index, list) => {
      //cleanup
      $(list).children('.c-limited-list__expand').remove();
      $(list)
        .children('.c-limited-list__item--hidden')
        .removeClass('c-limited-list__item--hidden')
        .removeAttr('style');

      //build new lists
      this.controlFilterList(list);
    });
  }

  _checkHiddenOnes(list) {
    let hidden = $(list).children('.c-limited-list__item--hidden');

    if (hidden.length) {
      $(list).append(`<li class="c-limited-list__expand"><button class="c-limited-list__expand__bt">Show All</button></li>`)
      //console.log('has some hidden items');
    } else {
      $(list).find('.c-limited-list__expand').remove();
    }
  }

  controlFilterList(list, limit = 5) {
    let items = $(list).children('.c-limited-list__item');

    $(list).on('click', '.c-limited-list__expand__bt',  (event) => {
      event.preventDefault();

      $(list)
        .children('.c-limited-list__item--hidden')
        .css('display', 'none')
        .removeClass('c-limited-list__item--hidden')
        .fadeIn(600);

      this._checkHiddenOnes(list);
    });

    if (items.length > limit) {
      for (let i = limit; i < items.length; i++) {
        $(items[i]).addClass('c-limited-list__item--hidden');
      }
      this._checkHiddenOnes(list);
    }
  }

}

export default LimitedList;
